const servicesTypes = {
	GET_POSES: {
		REUQEST: 'POSE_GET_REQUEST',
		SUCCESS: 'POSE_GET_SUCCESS',
		FAILURE: 'POSE_GET_FAILURE',
		CLEAR: 'POSE_GET_CLEAR',
	},
	GET_POSES_ITEM: {
		REUQEST: 'POSE_ITEM_GET_REQUEST',
		SUCCESS: 'POSE_ITEM_GET_SUCCESS',
		FAILURE: 'POSE_ITEM_GET_FAILURE',
		CLEAR: 'POSE_ITEM_GET_CLEAR',
	},
	SET_POSES: {
		REUQEST: 'POSE_SET_REQUEST',
		SUCCESS: 'POSE_SET_SUCCESS',
		FAILURE: 'POSE_SET_FAILURE',
		CLEAR: 'POSE_SET_CLEAR',
	},
	UPDATE_POS: {
		REUQEST: 'POS_UPDATE_REQUEST',
		SUCCESS: 'POS_UPDATE_SUCCESS',
		FAILURE: 'POS_UPDATE_FAILURE',
		CLEAR: 'POS_UPDATE_CLEAR',
	},
	DEACTIVE_POSES: {
		REUQEST: 'POSE_DEACTIVE_REQUEST',
		SUCCESS: 'POSE_DEACTIVE_SUCCESS',
		FAILURE: 'POSE_DEACTIVE_FAILURE',
	},
	EDIT_POSE: {
		REUQEST: 'POSE_EDIT_REQUEST',
		SUCCESS: 'POSE_EDIT_SUCCESS',
		FAILURE: 'POSE_EDIT_FAILURE',
	},
	SET_PACKAGES: {
		REUQEST: 'PACKAGES_SET_REQUEST',
		SUCCESS: 'PACKAGES_SET_SUCCESS',
		FAILURE: 'PACKAGES_SET_FAILURE',
	},
	GET_PACKAGES: {
		REUQEST: 'PACKAGE_GET_REQUEST',
		SUCCESS: 'PACKAGE_GET_SUCCESS',
		FAILURE: 'PACKAGE_GET_FAILURE',
		CLEAR: 'PACKAGE_GET_CLEAR',
	},
	GET_PRODUCTS: {
		REUQEST: 'PRODUCTS_GET_REQUEST',
		SUCCESS: 'PRODUCTS_GET_SUCCESS',
		FAILURE: 'PRODUCTS_GET_FAILURE',
	},
	SUMMARY: {
		REQUEST: 'SUMMARY_REQUEST',
		SUCCESS: 'SUMMARY_SUCCESS',
		FAILURE: 'SUMMARY_FAILURE',
		CLEAR: 'SUMMARY_CLEAR',
	},
};

export default servicesTypes;
